var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGearH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 86.38 86.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:#818082;}.f{fill:url(#d);stroke:#818082;stroke-miterlimit:10;stroke-width:2px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 2802.64,
    y1: -709.51,
    x2: 2887.44,
    y2: -709.51,
    gradientTransform: "translate(2953.3 402.25) rotate(173.03) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfd1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#c9cbcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#b9bbbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#9ea0a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e9092"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M3.81,58.82c.2,.95,1.14,1.55,2.09,1.34,.11-.02,.21-.06,.31-.1l4.65-.95c1.23-.25,2.19,.18,2.88,1.3,.04,.08,.1,.16,.16,.23l5.39,7.36-3.02,5.48c-.73,1.31-.65,1.98,.49,2.89,2.63,2.12,5.52,3.91,8.6,5.32,.5,.23,1.03,.4,1.58,.49,.81,.22,1.65-.15,2.04-.9,1.19-1.89,2.45-3.72,3.51-5.31l11.31,1.73c.54,1.95,1.17,4.11,1.79,6.28,.13,.94,1,1.59,1.94,1.46,.05,0,.09-.01,.14-.03,3.8-.39,7.52-1.3,11.07-2.7,1.01-.27,1.6-1.31,1.33-2.31,0-.03-.02-.06-.03-.09-.36-1.86-.7-3.89-1.13-5.83-.2-.48,.03-1.03,.51-1.23,.04-.02,.08-.03,.12-.04,.76-.36,1.47-.79,2.14-1.29,2.07-1.55,4.12-3.13,6.24-4.76l5.89,3.25c.9,.48,1.65,.44,2.17-.27,2.51-3.07,4.59-6.47,6.18-10.11,.44-.91,.08-2.01-.82-2.49-.79-.53-1.61-1.02-2.42-1.6s-2.09-1.51-3.24-2.25c1.06-3.25,1.61-6.63,1.64-10.05-.08-.56,.31-1.07,.87-1.15h0c1.84-.53,3.67-1.08,5.5-1.66,1.43-.44,1.91-1.01,1.6-2.44-.55-2.92-1.2-5.8-1.9-8.68-.26-.86-.63-1.68-1.11-2.43-.4-.81-1.35-1.18-2.2-.87-1.85,.45-3.9,.76-5.83,1.15-.4,.15-.85-.05-1-.45,0-.02-.01-.03-.02-.05-.36-.72-.77-1.41-1.24-2.07-1.59-2.14-3.22-4.28-4.88-6.47l3.1-5.72c.61-.74,.52-1.83-.22-2.44-.1-.08-.2-.15-.31-.21-2.9-2.33-6.1-4.28-9.51-5.78-.88-.56-2.05-.3-2.6,.58-.05,.09-.1,.18-.14,.27-1.13,1.68-2.25,3.34-3.36,5.03-.17,.36-.59,.52-.95,.35h-.01c-3.15-.95-6.41-1.45-9.69-1.52-.49,.06-.75-.1-.9-.65-.57-2.02-1.2-4.04-1.8-6.05-.17-.91-1.04-1.52-1.95-1.35-.04,0-.07,0-.11,.02-3.77,.4-7.46,1.3-10.98,2.69-1.02,.22-1.67,1.22-1.45,2.24,.02,.1,.05,.21,.09,.31,.4,1.85,.81,3.82,1.16,5.73,.05,.39-.09,.78-.37,1.05-3.08,1.72-5.91,3.87-8.38,6.39l-1.54-.8c-1.53-.82-3.02-1.7-4.58-2.44-.77-.57-1.86-.42-2.43,.35-.08,.11-.15,.23-.2,.35-1.29,1.85-2.61,3.68-3.76,5.63-.77,1.28-1.41,2.63-1.9,4.03-.42,1.21-.07,1.78,.99,2.48,1.63,1.07,3.27,2.15,4.84,3.21,.26,.21,.39,.53,.37,.87-.91,3.21-1.43,6.53-1.55,9.86-.05,.32-.26,.59-.56,.71-1.82,.62-3.82,1.21-5.77,1.75-1.32,.39-1.78,1.02-1.61,2.35,.39,2.25,.78,4.52,1.32,6.74,.37,1.45,.87,2.88,1.47,4.25v.02ZM37.22,18.79c13.51-3.34,27.16,4.91,30.49,18.41,3.34,13.51-4.91,27.16-18.41,30.49-13.51,3.34-27.16-4.91-30.49-18.41h0c-3.32-13.51,4.92-27.15,18.42-30.49h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M38.48,53.24h-3.64v-19.6h3.64v19.6Zm10.42-8.4h-10.72v-3.11h10.72v3.11Zm-.28-11.2h3.64v19.6h-3.64v-19.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearH);
export default __webpack_public_path__ + "static/media/gear-h.f44d13167938294ee36a1af832ccf55a.svg";
export { ForwardRef as ReactComponent };